import React from 'react'
import TopBreadcrumb from 'components/TopBreadCrumb'
import ExamAnalysis from '../../Exam/ExamAnalysisV2/ExamAnalysis'

const Page = () => {
  const breadcrumbList = [{ name: '看板' }, { name: '操作看板' }, { name: '竞赛' }]
  return (
    <div
      style={{ height: '100%', display: 'flex', flexDirection: 'column', padding: '0 24px 24px' }}
    >
      <TopBreadcrumb breadcrumbList={breadcrumbList} />
      <ExamAnalysis customStyle={{ padding: 0 }} hideExamInfoBar={true} />
    </div>
  )
}

export default Page
